import React from 'react';
import { makeStyles } from '@mui/styles';
import { Box, Typography } from '@mui/material';
import { Button } from '@qrios/frontend-library';
import { Status } from '../profile-creation-blocked/interfaces';
import Divider from '../../../../common/divider/divider';
import { convertToKebabCase } from '../../../../../constants/helpers/text';

interface StyleProps {
  status: Status;
}

const useStyles = makeStyles(theme => ({
  container: {
    width: theme.customComponents.profileCreation.container.width,
    maxWidth: '690px',
    padding: theme.spacing(3),
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column'
  },
  titleContainer: {
    color: ({ status }: StyleProps) => (status === 'blocked' ? theme.palette.error.main : 'inherit'),
    marginBottom: theme.spacing(2)
  }
}));

interface Props {
  title: string;
  status: Status;
  submitHandler: () => void;
  handleCancel: () => void;
}

const PageContent = ({ title, status, handleCancel, submitHandler }: Props) => {
  const classes = useStyles({ status });

  const actions = {
    standardOption: {
      type: 'button' as const,
      handler: () => handleCancel(),
      text: 'I want to register standard account'
    },
    invitationOption: {
      type: 'button' as const,
      handler: () => submitHandler(),
      text: 'I have an invitation code'
    }
  };

  return (
    <Box className={classes.container}>
      <Box>
        <Typography color="inherit" align="center" variant="h2">
          {title}
        </Typography>
        <Divider />
      </Box>
      <Box alignItems="center">
        <Box width="100%">
          <Button
            fullWidth
            text={actions.standardOption.text}
            variant="outlined"
            onClick={actions.standardOption.handler}
            data-testid={`button-${convertToKebabCase(actions.standardOption.text)}`}
          />
        </Box>
        <Box width="100%" mt={1}>
          <Button
            fullWidth
            text={actions.invitationOption.text}
            variant="outlined"
            onClick={actions.invitationOption.handler}
            loading={false}
            type="submit"
            data-testid={`button-${convertToKebabCase(actions.invitationOption.text)}`}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PageContent;
